import { useNavigate } from 'react-router';

import { ButtonSecondary, ButtonTertiary } from '@anwb/poncho/components/button';
import { useGaFunnelInfo } from 'hooks/useGaFunnelInfo';
import { STEPS, gotoStep } from 'utils/navigation';

import { NavigationButtonContainer } from './styles/navigation-button.styled';

type NavigationButtonsProps = {
	onSubmit?: () => void;
};

export const NavigationButtons = ({ onSubmit }: NavigationButtonsProps) => {
	const navigate = useNavigate();
	const gaFunnelInfo = useGaFunnelInfo();

	return (
		<NavigationButtonContainer>
			<ButtonTertiary
				data-test="button-back"
				icon="arrow-left"
				iconPosition="before"
				type="button"
				onClick={() => {
					gotoStep(
						STEPS.CAR_CONTRACT,
						'Terug naar step 1',
						navigate,
						gaFunnelInfo,
						'navigation-button'
					);
				}}
			>
				Terug
			</ButtonTertiary>
			<ButtonSecondary
				type="button"
				data-test="button-next"
				icon="arrow-right"
				iconPosition="after"
				onClick={onSubmit}
			>
				Naar het overzicht
			</ButtonSecondary>
		</NavigationButtonContainer>
	);
};
